'use strict';
//utils
var React = require('react');
var Classnames = require('classnames');
var _ = require('lodash');
//components
var SectionHeader = require('../Common/SectionHeader.jsx');
var OtherFundTypes = require('./OtherFundTypes.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
var FundingSummary = require('./FundingSummary.jsx');
//constants
var Labels = require('../../constants/FundingYourProductConstants.js').Labels;
var SectionNames = require('../../constants/FundingYourProductConstants.js').SectionNames;
var MessageTypes = require('../../constants/ApplicationConstants').messageTypes;
//store
var FundingYourProductStore = require('../../stores/FundingYourProductStore.js');
//action
var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');
var ApplicationActions = require('../../actions/ApplicationActions.js');
//utils
var Mapper = require('../../utils/Mapper.js');
var Formatter = require('../../utils/Formatter.js');
var FundingYourProductHelper = require('../../utils/FundingYourProductHelper.js');
var Screen = require('../../utils/Screen.js');

var pageCopy = {
    question: '',
    sectionName: '',
    helpText: '',
    buttonLabel: '+ Add funding type',
    totalLabel: 'Approximate total:',
    futureRequestText: '',
    directDebitAlreadyAddedText: ''
};

var setupErrorInfo = {
    valid: true,
    heading: '',
    message: '',
    internalAccounts: FundingYourProductStore.getInternalAccounts()
}

function getStateFromStores() {
    return {
        newFundingType: FundingYourProductStore.getNewFundingType(),
        fundTypesVisibility: FundingYourProductStore.getFundTypeVisibility(),
        summaryData: FundingYourProductStore.getSummaryData(),
        totalRollovers: FundingYourProductStore.getTotalRollovers(),
        setupErrorInfo: FundingYourProductStore.getSetupErrorInfo() ? FundingYourProductStore.getSetupErrorInfo() : setupErrorInfo,
        bankAccountList: FundingYourProductStore.getBankAccounts(),
        internalAccounts: FundingYourProductStore.getInternalAccounts(),
        activeFundType: FundingYourProductStore.getActiveFundType(),
        paymentMethodsInvestment: FundingYourProductStore.getPaymentMethodsInvestment(),
        isEditMode: FundingYourProductStore.getIsEditMode(),
        internalRolloverInfo: FundingYourProductStore.getInternalRolloverInfo(),
        hasDirectDebit: FundingYourProductStore.getHasDirectDebit()
    }
}

var FundingYourInvestmentSection = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },
    // Add change listeners to stores
    componentDidMount: function () {
        FundingYourProductStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        FundingYourProductStore.removeChangeListener(this._onChange);
    },

    componentWillUpdate: function(nextProps, nextState) {
        if (nextState.totalRollovers !== this.state.totalRollovers) {
            ApplicationActions.sendFundingAmount(nextState.totalRollovers);
            ApplicationActions.isFundingSummary(nextState.summaryData);
        } else if (!nextState.isEditMode && this.state.isEditMode) {
            ApplicationActions.isFundingSummary(nextState.summaryData);
        }

        if (!_.isEqual(nextState.summaryData, this.state.summaryData) && (nextState.summaryData.length > this.state.summaryData.length || (nextState.summaryData.length === this.state.summaryData.length && !nextState.isEditMode))) {
            const scrollYPosition = Screen.getScrollYPosition();
            window.scrollTo(0, scrollYPosition - 85);
            this.refs.fundingYourInvestmentSection.focus();
        }
    },

    //Event handler for 'change' events coming from the stores
    _onChange: function () {
        this.setState(getStateFromStores());
    },
    getCopy: function () {
        pageCopy.question = Mapper.getObjectByAttribute(Labels, this.props.productId, 'id').label;
        pageCopy.sectionName = Mapper.getObjectByAttribute(SectionNames, this.props.productId, 'id').label;
        pageCopy.helpText = this.props.content.fundingYourProduct[this.props.productId].sectionHelp;
        pageCopy.futureRequestText = this.props.content.fundingYourProduct[this.props.productId].futureRequestsHelp;
        pageCopy.directDebitAlreadyAddedText = this.props.content.fundingYourProduct[this.props.productId].directDebitAlreadyAddedHelp;
    },
    showPaymentMethods: function () {
        var self = this;
        setTimeout( function() {
            self.checkFundingPrerequisites();
            if (self.state.setupErrorInfo.valid) {
                FundingYourProductActions.toggleFundingTypeVisibility();
                self.setState({ showPaymentMethods: true });
            }
        }, 100);
    },
    checkFundingPrerequisites: function () {
        FundingYourProductActions.validateSectionSetup();
    },

    cancelEditMode: function () {
        this.setState({ showPaymentMethods: false });
        FundingYourProductActions.setActiveFundType('');
        FundingYourProductActions.toggleFundingTypeVisibility();
    },

    finishEditMode: function () {
        if (FundingYourProductHelper.isInternal(this.state.newFundingType.paymentMethod)) {
            FundingYourProductActions.submitInternalRollover();
        } else {
            FundingYourProductActions.submitOtherFundType(this.props.activeFundType);
        }
        if (this.state.newFundingType.errorList.length === 0) {
            this.setState({ showPaymentMethods: false });
            FundingYourProductActions.setActiveFundType('');
        }
    },

    render: function () {
        var showPaymentMethods = this.showPaymentMethods;
        this.getCopy(); //get label and section name
        var totalAmount = Formatter.currencyFormat(this.state.totalRollovers.toString());
        var renderTableActions = function (fundTypesVisibility, summaryData, totalRollovers, pageCopy, isEditMode) {
            if (!fundTypesVisibility || summaryData.length > 0) {
                return <table id="fypTableActions" className="table funding-your-section-table-actions">
                            <tfoot>
                                <tr>
                                    <td className="add-fund-button table-actions">
                                        <button type="button"
                                                id="fypAddFundButton"
                                                className={Classnames('btn btn-default btn-lg', { hidden: fundTypesVisibility || isEditMode })}
                                                onClick={showPaymentMethods}>
                                            {pageCopy.buttonLabel}
                                        </button>
                                    </td>
                                    <td colSpan="3" className={Classnames('funding-summary-total table-percent text-right ', { hidden: summaryData.length === 0 })}>
                                                                            <small>{pageCopy.totalLabel}</small>&nbsp;&nbsp;&nbsp;
                                                                            <strong>${totalRollovers}</strong>
                                    </td>
                                </tr>
                            </tfoot>
                </table>;
            }
        }
        var summary = this.state.summaryData.length > 0
                    ? <FundingSummary data={this.state.summaryData}
                                      productId={this.props.productId}
                                      internalAccounts={this.state.internalAccounts}
                                      content={this.props.content} 
                                      bankAccountList={this.state.bankAccountList}
                                      directDebitAlreadyAddedText={pageCopy.directDebitAlreadyAddedText}
                                      futureRequestText={pageCopy.futureRequestText}
                                      paymentMethodsInvestment={this.state.paymentMethodsInvestment}
                                      internalRolloverInfo={this.state.internalRolloverInfo}/>
                    : null;
        return (
        <div id="fundingYourProductSection" ref="fundingYourInvestmentSection">
            <SectionHeader focus={this.props.focus} sectionName={pageCopy.sectionName} sectionHelpText="Need help?" NeedHelpInfo={pageCopy.helpText} />
            <div className="container">
                <div className="form-section">
                    <div className={Classnames('form-label-section', { hidden: this.state.showPaymentMethods || this.state.summaryData.length > 0 })}>
                        <label>{pageCopy.question}</label>
                    </div>
                    {summary}
                    {renderTableActions(this.state.fundTypesVisibility, this.state.summaryData, totalAmount, pageCopy, this.state.isEditMode)}
                    {this.state.showPaymentMethods && this.state.fundTypesVisibility ? <OtherFundTypes content={this.props.content}
                                                                     data={this.state.newFundingType}
                                                                     product={this.props.productId} 
                                                                     bankAccountList={this.state.bankAccountList}
                                                                     directDebitAlreadyAddedText={pageCopy.directDebitAlreadyAddedText}
                                                                     futureRequestText={pageCopy.futureRequestText}
                                                                     internalAccounts={this.state.internalAccounts} 
                                                                     onCancelClick={this.cancelEditMode}
                                                                     onDoneClick={this.finishEditMode}
                                                                     activeFundType={this.state.activeFundType}
                                                                     paymentMethodsInvestment={this.state.paymentMethodsInvestment}
                                                                     internalRolloverInfo={this.state.internalRolloverInfo}
                                                                     hasDirectDebit={this.state.hasDirectDebit} /> 
                                                   : null }
                    <InlineMessage id="fypErrorMessageSetupError"
                                   type={MessageTypes.error}
                                   message={this.state.setupErrorInfo.inline}
                                   isHidden={this.state.setupErrorInfo.valid} />
                </div>
            </div>
        </div>
        );
    }
});

module.exports = FundingYourInvestmentSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/FundingYourInvestmentSection.jsx